import React from 'react';
import { Link } from 'react-router-dom';
import GetOfferMoto from '../components/GetOfferMoto';
import '../components/GetOfferMoto.css';

const MotorradGetOffer = () => {
    return (
        <div className="form-page-wrapper">
            <div className="form-page-inner">
                <Link to="/moto_models" className="get-offer-back-link">‹ Назад к моделям</Link>
                <GetOfferMoto />
            </div>
        </div>
    );
};

export default MotorradGetOffer;